<template>
  <div>
    <div class="screen-reader" :class="{ show }" id="screen-reader">
      <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve">
        <a rel="nofollow" class="rsbtn_play" accesskey="L" title="Lyssna p&aring; sidans text med ReadSpeaker webReader" :href="`//app-eu.readspeaker.com/cgi-bin/rsent?customerid=9832&amp;lang=sv_se&amp;readid=${readId}&amp;url=${url}`">
          <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span>Lyssna</span></span></span>
          <span class="rsbtn_right rsimg rsplay rspart" ref="player"></span>
        </a>
      </div>
    </div>
    <div class="screen-reader-btn" :class="{ ready: isReady }">
      <button
          accesskey="L"
          :data-url="`//app-eu.readspeaker.com/cgi-bin/rsent?customerid=9832&amp;lang=sv_se&amp;readid=${readId}&amp;url=${url}`"
          @click.prevent="handleClick"
      >
        Lyssna
      </button>
    </div>
  </div>

</template>

<script>
/* global ReadSpeaker */
export default {
  name: 'ScreenReaderBtn',

  data: () => ({
    isReady: false,
    show: false,
    url: encodeURIComponent(window.location.href),
    readId: 'content'
  }),

  mounted () {
    const script = document.createElement('script')
    script.onload = () => {
      console.log('ReadSpeaker ready')
      this.isReady = true
      ReadSpeaker.init()
    }

    script.async = true
    script.src = '//cdn1.readspeaker.com/script/9832/webReader/webReader.js?pids=wr'
    document.head.appendChild(script)
  },

  methods: {
    handleClick: function () {
      this.show = !this.show
    }
  },

  watch: {
    show (value) {
      const evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })

      if (value) {
        this.$nextTick(function () {
          this.$refs.player.dispatchEvent(evt)
        })
      }
      // If cancelled, don't dispatch our event
      // const canceled = !elem.dispatchEvent(evt);
    }
  }
}
</script>

<style scoped>

</style>
